import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useCrudEditContext } from "@ryde/redux";
import {
  DATA_E2E_KEY,
  ICustomField,
  INotificationDto,
  IStyledAttributes,
} from "@ryde/shared";

import { GenericReadonlyTemplateStyled } from "../../common/generic-readonly/generic-readonly.styled";
import { useOpenEntityFormCellTemplate } from "./hooks";

const OpenEntityFormTemplatedStyled = styled(
  GenericReadonlyTemplateStyled,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "open-entity-form-templated",
})`
  .OpenEntityFormTemplated-Link {
    text-decoration: underline;
  }
`;

export const OpenEntityFormTemplated: FC<ICustomField> = () => {
  const {
    data: { dto },
  } = useCrudEditContext<INotificationDto>();
  const { openEntityForm } = useOpenEntityFormCellTemplate();
  const { t } = useTranslation();

  const onClickHandler = (): void => {
    if (!dto?.entityName || !dto?.entityRecordId) {
      return;
    }

    openEntityForm({
      entity: dto?.entityName,
      id: dto?.entityRecordId,
    });
  };

  return (
    <OpenEntityFormTemplatedStyled className="pointer" onClick={onClickHandler}>
      <label className="GenericReadonlyTemplate-Label">
        {t("notification.formLabel.openEntityForm")}
      </label>
      <span className="OpenEntityFormTemplated-Link GenericReadonlyTemplate-Value">
        {dto?.entityName}
      </span>
    </OpenEntityFormTemplatedStyled>
  );
};
